import { lazy } from 'react';

export const PlayerGlobalLossLimitsForm = lazy(
  () => import('./PlayerGlobalLossLimitsForm'),
);
